module.exports = __webpack_public_path__ + "static/media/tanda-tangan-digital-kominfo_20161122_140417.b3b727da.jpg";